(function () {

  'use strict';

  /**
   * @author Ronald Nicholls | Chester Rivas
   * @class ute-ui.content
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .directive('uteContentInjector', ['$rootScope', '$templateCache', 'uteContentLoader', '$cookies', 'uteLocale', function ($rootScope, $templateCache, uteContentLoader, $cookies, uteLocale) {

      return {
        scope: {
          localContentId: '@',
          contentId: '@',
          compile: '=',
          province: '@',
          language: '@'
        },
        replace: true,
        restrict: 'EA',
        controller: ['$scope', '$element', function ($scope, $element) {

          /**
           * @description toggle for showing meta data for developer purposes
           * @name metaShown
           * @memberOf ute-ui.content.uteContentInjector
           */
          var metaShown = false,
            containerWidth = $element[0].offsetWidth;

          if (containerWidth <= 500) {
            $element.addClass('cms-content-width-narrow');
          }

          /**
           * @description toggle hidden dev divs and displays metadata after user clicks hidden cms-metadata-toggle div
           * @name displayMetadata
           * @memberOf ute-ui.content.uteContentInjector
           */
          var displayMetadata = function () {

            metaShown = !metaShown;
            var settings = {
              scope: $scope,
              element: $element,
              method: 'GET',
              dataType: 'json',
              fileType: '.json',
              contentId: $scope.contentId,
              compile: angular.isDefined($scope.compile) && $scope.compile || false,
              language: $scope.language || uteLocale.language,
              province: $scope.province || uteLocale.province,
              localContentId: $scope.localContentId
            };

            metaShown ? uteContentLoader.makeRequest(settings) : $element.children().children()[0].remove();

          };

          /**
           * @description add and removed active from cms-metadata div
           * @name metadataActive
           * @memberOf ute-ui.content.uteContentInjector
           */
          var metadataActive = function () {
            $(this).toggleClass('active');
          };

          /**
           * @description inits the directive
           * @name init
           * @memberOf ute-ui.content.uteContentInjector
           */
          var init = function () {

            $('ins').off().on('click', '.cms-metadata', metadataActive);

            $element.addClass('preloader loading');

            if (!$rootScope.ute) {
              $rootScope.ute = {
                language: 'en',
                province: 'on'
              };
            }

            makeRequest();

            //TODO - change .bind to .on method
            angular.element(document.getElementById('cms-metadata-toggle')).bind('click', displayMetadata);

          };

          /**
           * @description makes http request, also called by watcher
           * @name makeRequest
           * @memberOf ute-ui.content.uteContentInjector
           */
          var makeRequest = function () {

            var settings = {
              scope: $scope,
              element: $element,
              method: 'GET',
              dataType: 'html',
              fileType: '.html',
              contentId: $scope.contentId,
              compile: angular.isDefined($scope.compile) && $scope.compile || false,
              language: $scope.language || uteLocale.language || $cookies.get('language') || 'en',
              province: $scope.province || uteLocale.province || $cookies.get('province') || 'on',
              localContentId: $scope.localContentId
            };

            uteContentLoader.makeRequest(settings);

          };

          /**
           * @description checks to see if new values are different from the old values then makes an http request again
           * @name metaShown
           * @param oldValue
           * @param newValue
           * @memberOf ute-ui.content.uteContentInjector
           */
          var update = function (oldValue, newValue) {
            if (oldValue !== newValue) {
              makeRequest();
            }
          };

          init();

          $scope.$watch('language', update);
          $scope.$watch('province', update);
          $scope.$watch('contentId', update);


        }]

      };

    }]);

})();
